<!-- 企信转单操作模块 -->
<template>
    <div class="msgSetting business-page">
        <div class="business-content">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" :key="$route.name"/>
            </keep-alive>
            <router-view  v-if="!$route.meta.keepAlive" />
        </div>
    </div>
</template>
<script>
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
  },
  data() {
    return {
      nav: {},
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
